module.exports = __webpack_public_path__ + "static/media/IconCheck3.c8fbd46c.svg";